/* eslint-disable no-continue */
/* eslint-disable no-plusplus */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import * as S from "./styles";

import { Simulate } from "react-dom/test-utils";
import CompleteBox from "../../components/CompleteBox";
import PartnerLink from "../../components/PartnerLink";
import PageFooter from "../../components/PageFooter";
import axios from "axios";
import { FormProps } from "../../store";

const ProgramEnd = ({
  partnerLink,
  partnerImage,
  partnerName,
  programTitle,
}: {
  partnerLink: string;
  partnerImage: string;
  partnerName: string;
  programTitle: string;
}) => {
  const title = "모집이 종료되었습니다.";
  const text = `<p><b>${programTitle}</b> 프로그램은 모집이 종료되었습니다.</p>`;

  return (
    <div>
      <PartnerLink link={partnerLink} image={partnerImage} />
      <CompleteBox completeTitle={title} completeText={text} />
      <PageFooter partnerName={partnerName} />
    </div>
  );
};

export default ProgramEnd;
